// import React from 'react';
// const LanguageContext = React.createContext({
// 	language: 'da-DK',
// 	setLanguage: () => {},
// });
// export default LanguageContext;

import React from 'react';
const LanguageContext = React.createContext();
export default LanguageContext;